function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import Typography from "@material-ui/core/Typography";
import data from "./License.data.json";
import LicenseIcon from "./LicenseIcon";
const useStyles = makeStyles(theme => ({
  root: {
    "& .MuiFormLabel-root": {
      fontFamily: "Akkurat, sans-serif"
    },
    "& .MuiInputBase-root": {
      fontFamily: "Akkurat, sans-serif",
      borderTopLeftRadius: "0",
      borderTopRightRadius: "0",
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(1)
    },
    "& .MuiFormLabel-root": {
      fontFamily: "Akkurat, sans-serif"
    },
    "& .MuiAutocomplete-inputRoot[class*=MuiFilledInput-root] .MuiAutocomplete-input": {
      padding: theme.spacing(.25, .5)
    },
    "& .MuiAutocomplete-tag": {
      margin: theme.spacing(.25)
    }
  },
  option: {
    display: "flex",
    alignItems: "center",
    "& > * + *": {
      marginLeft: theme.spacing(1)
    }
  },
  icon: {
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap",
    "& > * + *": {
      marginLeft: theme.spacing(.5)
    }
  },
  text: {
    fontFamily: "Akkurat, sans-serif",
    lineHeight: 1,
    "& > * + *": {
      marginLeft: theme.spacing(.5)
    }
  },
  label: {
    color: theme.palette.text.primary
  },
  value: {
    fontFamily: "Akkurat, sans-serif",
    color: theme.palette.text.secondary
  }
}));

const SelectLicenseFieldOption = ({
  value,
  label,
  system
}) => {
  const classes = useStyles();
  return React.createElement("div", {
    className: classes.option
  }, React.createElement(LicenseIcon, {
    className: classes.icon,
    license: value
  }), React.createElement(Typography, {
    className: classes.text
  }, React.createElement("b", {
    className: classes.label
  }, label), React.createElement("i", {
    className: classes.value
  }, "(", value, ")")));
};

const SelectLicense = ({
  id,
  label = "Select icon",
  helperText,
  value,
  required,
  disabled,
  readonly,
  multiple,
  autofocus,
  onChange,
  placeholder
}) => {
  const _useTranslation = useTranslation(),
        t = _useTranslation.t,
        i18n = _useTranslation.i18n;

  const getOptions = () => {
    const options = data.map(option => {
      const group = option.group,
            value = option.value;
      return _extends({}, option, {
        group: group && t("licenseGroup:" + group)
      });
    });
    options.sort((a, b) => a.groupId > b.groupId ? 1 : -1);
    return options;
  };

  const emptyValue = multiple ? [] : "";
  const options = getOptions();

  const handleChange = (event, option) => {
    onChange && onChange(option && option.value || emptyValue, event);
  };

  const renderGroup = option => {
    return React.createElement("p", null, JSON.stringify(option.group));
  };

  const renderOption = (option, state) => {
    return React.createElement(SelectLicenseFieldOption, option);
  };

  let selected = value && options.filter(option => option.value == value);

  if (!multiple && selected.length) {
    selected = selected[0];
  }

  const classes = useStyles();
  return React.createElement(Autocomplete, {
    className: classes.root,
    id: id,
    placeholder: placeholder,
    multiple: multiple,
    options: options,
    groupBy: option => option.group,
    label: label,
    helperText: helperText,
    value: selected,
    required: required,
    disabled: disabled || readonly,
    autoFocus: autofocus,
    groupBy: option => option.group //            getOptionSelected={(option, value) => option.value === value}
    ,
    getOptionLabel: option => options && option.label || "" //            renderGroup={renderGroup}
    ,
    renderOption: renderOption,
    renderInput: params => React.createElement(TextField, _extends({}, params, {
      className: classes.input,
      variant: "filled",
      label: label,
      placeholder: placeholder,
      helperText: helperText
    })),
    onChange: handleChange
  });
};

SelectLicense.defaultProps = {
  autofocus: false
};
SelectLicense.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.string,
  value: PropTypes.any,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  multiple: PropTypes.bool,
  autofocus: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func
} : {};
export default SelectLicense;